import { AuthContext } from 'contexts/AuthContext';
import { ISupplier } from 'hooks/useSuppliers';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { controlledFetch } from 'utils/http';
import Cookies from 'universal-cookie';
import { getByToken } from '../../controllers/pessoa';

export const useSuppliers = () => {
  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  const [currentSupplierId, setCurrentSupplierId] = useState(0);
  const [supplierLoading, setSupplierLoading] = useState(false);

  const handleChangeSupplier = (_: React.ChangeEvent, supplier: ISupplier | null) => {
    const supplierId = supplier ? parseInt(supplier.id) : 0;
    setCurrentSupplierId(supplierId);
  };

  const getUserInfo = useCallback(async () => {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const { codigo, nome } = await getByToken(token).then((response) => {
      const { itens } = JSON.parse(response.body);
      return itens;
    });

    return { id: codigo, nome };
  }, []);

  const controlledGetUserInfo = controlledFetch(getUserInfo);
  const loadUserInfo = useCallback(async () => {
    setSupplierLoading(true);

    await controlledGetUserInfo()
      .then(({ id }) => {
        setCurrentSupplierId(id);
      })
      .finally(() => {
        setSupplierLoading(false);
      });
  }, []);

  useEffect(() => {
    const setSupplier = async () => {
      if (!isVisaoTok) {
        await loadUserInfo();
      }
    };

    setSupplier();
  }, [loadUserInfo]);

  return { currentSupplierId, handleChangeSupplier, supplierLoading };
};
